export default __webpack_public_path__ + "static/media/presentaciones-ciclo.a325556c.png";